import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faCopy, faSun } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class WorkflowTasks extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDaily: true,
      showMonthly: true,
      showQuarterly: true,
      showAnnually: true,
      showUnset: true
    };
    this.scrollDivWorkflowTask = React.createRef();
  }

  standardRow = (workflowTask) => {
    this.props.info('WorkflowTasks.js/standardRow (workflowTask)', workflowTask);
    return (
      <Row className="adminRow pointer" onClick={() => this.props.onEdit(workflowTask.id)}>
        <Col md={4} className="text-left">
          <FontAwesomeIcon icon={(workflowTask['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((workflowTask['active']) ? 'iconActive' : 'iconInactive')} />
          {workflowTask['name']}
          {workflowTask['morningProcess'] && <FontAwesomeIcon icon={faSun} className={"ml-2 text-warning"} />}
        </Col>
        <Col md={2}>
          {workflowTask.completionBusinessDays > 0 ? <>{workflowTask.completionBusinessDays} {(workflowTask.completionBusinessDays === 1 ? ' Bus. Day' : ' Bus. Days')}</> : <></>}
        </Col>
        <Col md={6} className="text-left">{workflowTask['description']}</Col>
      </Row>
    )
  }

  editRow = (workflowTask) => {
    this.props.log('WorkflowTasks.js/editRow (workflowTask)', workflowTask);
    return (
      <Row className="editRow adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Name"
                type="text"
                id="workflowTask-edit"
                name="name"
                value={this.props.isFieldNull(this.props.editWorkflowTask.name)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id="workflowTask-description"
                name="description"
                value={this.props.isFieldNull(this.props.editWorkflowTask.description)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Frequency"
                type="select"
                id="workflowTask-duration"
                name="duration"
                value={this.props.isFieldNull(this.props.editWorkflowTask.duration)}
                onChange={e => this.props.onChange(e, 'edit')} >
                <option value="0">Select Frequency</option>
                <option value="24">Daily</option>
                <option value="730">Monthly</option>
                <option value="2190">Quarterly</option>
                <option value="8760">Annually</option>
              </Input>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Completion Bus. Days"
                type="number"
                id="workflowTask-completion-business-days"
                name="completionBusinessDays"
                value={this.props.isFieldNull(this.props.editWorkflowTask.completionBusinessDays)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Time Target"
                type="number"
                id={"workflowTask-time-target" + workflowTask.id}
                name="timeTarget"
                value={this.props.isFieldNull(this.props.editWorkflowTask.timeTarget)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"edit-morningProcess" + workflowTask.id}
                name="morningProcess"
                checked={this.props.isFieldNull(this.props.editWorkflowTask.morningProcess,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-morningProcess" + workflowTask.id}>
                Morning Process
              </Label>
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"edit-automated" + workflowTask.id}
                name="automated"
                checked={this.props.isFieldNull(this.props.editWorkflowTask.automated,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-automated" + workflowTask.id}>
                Automated
              </Label>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"edit-active" + workflowTask.id}
                name="active"
                checked={this.props.isFieldNull(this.props.editWorkflowTask.active,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-active" + workflowTask.id}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Workflow Tasks">
            <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Workflow Task">
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Workflow Tasks">
            <Button className="mx-1" color="primary" onClick={() => { this.props.onCopy(workflowTask.id); window.scrollTo(0, this.scrollDivWorkflowTask.current.offsetTop);}} title="Copy Workflow Task">
              <FontAwesomeIcon icon={faCopy} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Workflow Tasks">
            <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(workflowTask.id)} edit="Delete Workflow Task">
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={6} className="text-right p-3">
          Assigned Workflows
        </Col>
        <Col md={6} className="text-left py-3 pl-5 maxHpanel">
          {this.props.workflows.findIndex(workflow => parseInt(workflow.duration) === parseInt(this.props.editWorkflowTask.duration)) > -1 ?
            this.props.workflows.filter(workflow => parseInt(workflow.duration) === parseInt(this.props.editWorkflowTask.duration)).map(workflow => (
              <div key={"workflow-" + workflow.id}><Label for={"workflow_" + workflow.id}>
                <Input
                  type="checkbox"
                  name="workflows"
                  id={"workflow_" + workflow.id + "_" + workflowTask.id}
                  checked={this.props.isFieldNull(this.props.editWorkflowTask.workflows.findIndex(i => i.id === parseInt(workflow.id)) > -1,true)}
                  onChange={e => this.props.onChange(e, 'edit')}
                />
                {workflow['name']}   {parseInt(workflow.completionBusinessDays) !== 0 && parseInt(workflow.completionBusinessDays) > 0 ?
                  (workflow.completionBusinessDays === 1 ? <span className="timerLine"> ({workflow.completionBusinessDays} Bus. Day)</span> : <span className="timerLine"> ({workflow.completionBusinessDays} Bus. Days)</span>)
                  : <></>}
              </Label></div>
            )) : <>No workflows for the selected frequency</>}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    this.props.info('WorkflowTasks.js/addRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            {/* <FormGroup className="pr-2">
              Add New Task
            </FormGroup> */}
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="New Task Name"
                type="text"
                id="workflowTask-add"
                name="name"
                value={this.props.isFieldNull(this.props.newWorkflowTask.name)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id="workflowTask-add-description"
                name="description"
                value={this.props.isFieldNull(this.props.newWorkflowTask.description)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Frequency"
                type="select"
                id="workflowTask-add-duration"
                name="duration"
                value={this.props.isFieldNull(this.props.newWorkflowTask.duration)}
                onChange={e => this.props.onChange(e)} >
                <option value="0">Select Frequency</option>
                <option value="24">Daily</option>
                <option value="730">Monthly</option>
                <option value="2190">Quarterly</option>
                <option value="8760">Annually</option>
              </Input>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Completion Bus. Days"
                type="number"
                id="workflowTask-add-completion-business-days"
                name="completionBusinessDays"
                value={this.props.isFieldNull(this.props.newWorkflowTask.completionBusinessDays)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Time Target"
                type="number"
                id={"workflowTask-add-time-target"}
                name="timeTarget"
                value={this.props.isFieldNull(this.props.newWorkflowTask.timeTarget)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"workflowTask-morningProcess"}
                name="morningProcess"
                checked={this.props.isFieldNull(this.props.newWorkflowTask.morningProcess,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"workflowTask-morningProcess"}>
                Morning Process
              </Label>
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"workflowTask-automated"}
                name="automated"
                checked={this.props.isFieldNull(this.props.newWorkflowTask.automated,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"workflowTask-automated"}>
                Automated
              </Label>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"workflowTask-active"}
                name="active"
                checked={this.props.isFieldNull(this.props.newWorkflowTask.active,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"workflowTask-active"}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newWorkflowTask.name === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Task</Button>
        </Col>
      </Row>
    )
  }

  render() {
    this.props.info('WorkflowTasks.js/render');
    return (
      <Container className="adminContainer" fluid>
        <Row className="text-left adminRow font-weight-bold">
          {this.props.workflowTasks.findIndex(workflowTask => workflowTask.duration === 24) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showDaily"
                checked={this.props.isFieldNull(this.state.showDaily,true)}
                onChange={() => this.setState({
                  showDaily: !this.state.showDaily
                })}
              /> Daily</Label>
            </Col> : <></>}
          {this.props.workflowTasks.findIndex(workflowTask => workflowTask.duration === 730) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showMonthly"
                checked={this.props.isFieldNull(this.state.showMonthly,true)}
                onChange={() => this.setState({
                  showMonthly: !this.state.showMonthly
                })}
              /> Monthly</Label>
            </Col> : <></>}
          {this.props.workflowTasks.findIndex(workflowTask => workflowTask.duration === 2190) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showQuarterly"
                checked={this.props.isFieldNull(this.state.showQuarterly,true)}
                onChange={() => this.setState({
                  showQuarterly: !this.state.showQuarterly
                })}
              /> Quarterly</Label>
            </Col> : <></>}
          {this.props.workflowTasks.findIndex(workflowTask => workflowTask.duration === 8760) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showAnnually"
                checked={this.props.isFieldNull(this.state.showAnnually,true)}
                onChange={() => this.setState({
                  showAnnually: !this.state.showAnnually
                })}
              /> Annually</Label>
            </Col> : <></>}
          {this.props.workflowTasks.findIndex(workflowTask => (workflowTask.duration == null || parseInt(workflowTask.duration) === 0)) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showUnset"
                checked={this.props.isFieldNull(this.state.showUnset,true)}
                onChange={() => this.setState({
                  showUnset: !this.state.showUnset
                })}
              /> Unset</Label>
            </Col> : <></>}
        </Row>
        {this.props.workflowTasks.filter(workflowTask => (this.state.showDaily && workflowTask.duration === 24)
          || (this.state.showMonthly && workflowTask.duration === 730)
          || (this.state.showQuarterly && workflowTask.duration === 2190)
          || (this.state.showAnnually && workflowTask.duration === 8760)
          || (this.state.showUnset && (workflowTask.duration == null || workflowTask.duration === 0))
        ).map(workflowTask => (
          <Fragment key={"workflowTask-" + workflowTask.id}>{this.props.editWorkflowTask.id === workflowTask.id ? this.editRow(workflowTask) : this.standardRow(workflowTask)}</Fragment>
        ))}
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Workflow Tasks">
          <div><div className="scrollDiv" ref={this.scrollDivWorkflowTask}></div>{this.addRow()}</div>
        </PermissionWrapper>
      </Container>
    );

  }
}

export default WorkflowTasks;